import { Box, type SxProps, type Theme } from '@mui/material'
import { ENV_NAME, IS_NON_PROD } from '@/config/environment'

/**
 * Subtle environment marker. Renders nothing in production; in any other
 * environment it shows the short env name (e.g. "dev") so prod and non-prod
 * builds are easy to tell apart at a glance. Inherits the surrounding text
 * colour so it works on both the navy navbar and the light auth card.
 */
export default function EnvBadge({ sx }: { sx?: SxProps<Theme> }) {
  if (!IS_NON_PROD) return null
  return (
    <Box
      component="span"
      title={`${ENV_NAME} environment`}
      sx={{
        px: 0.6,
        py: 0.1,
        fontSize: 10,
        lineHeight: 1.5,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        borderRadius: 0.75,
        border: '1px solid currentColor',
        opacity: 0.4,
        userSelect: 'none',
        ...sx,
      }}
    >
      {ENV_NAME}
    </Box>
  )
}
